module.exports = __webpack_public_path__ + "YoungSerif-Regular.859cf34faa8a068b30a4.svg";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/YoungSerif-Regular.svg
// module id = ../../../../../src-admin/assets/fonts/YoungSerif-Regular.svg
// module chunks = styles